import * as userApi from 'resources/user/user.api';

import auditService from 'resources/audit/audit.service';
import taskService from 'resources/task/task.service';
import dealService from 'resources/deal/deal.service';
import milestoneService from 'resources/milestone/milestone.service';

import * as dealHelpers from 'resources/deal/deal.helpers';
import * as auditHelpers from 'resources/audit/audit.helpers';

import { finishTransaction } from 'resources/deal/workflows';

import { TASK_STATUSES } from 'resources/task/task.constants';
import { MILESTONE_STATUSES } from 'resources/milestone/milestone.constants';
import { DEAL_ENDED_STATUSES, DEAL_STATUSES } from 'resources/deal/deal.constants';
import { HOME_LISTED_MILESTONE_NAME } from 'resources/listedkit/listedkit.constants';

export const actualizeTransactionStatusOnGeneralTaskStatusChange = async (milestone) => {
  if (milestone.name === HOME_LISTED_MILESTONE_NAME) {
    const deal = await dealService.findById(milestone.deal_id);

    if (dealHelpers.hasStartedTransaction(deal)) {
      return;
    }

    const homeListedMilestoneTasks = await taskService.getMilestoneTasks(milestone.id);

    const hasOpenTasks = homeListedMilestoneTasks.some((task) => task.status === TASK_STATUSES.OPEN);

    await dealService.updateOne({ id: deal.id }, {
      status: hasOpenTasks ? DEAL_STATUSES.PRE_LISTING : DEAL_STATUSES.HOME_LISTED_COMPLETED,
    });
  }
};

export const actualizeTransactionStatus = async (deal, userId) => {
  if (!deal || !dealHelpers.hasStartedTransaction(deal)) {
    return;
  }

  // close transaction if there is no open tasks and audits uncompleted
  const [milestones, audits] = await Promise.all([
    milestoneService.getUnderContractMilestonesByDealId(deal.id),
    auditService.getUnderContractAuditsByDealId(deal.id),
  ]);

  const openTasks = await taskService.findRequiredOpenUnderContractTasks(
    milestones
      .filter((m) => m.status === MILESTONE_STATUSES.ACTIVE)
      .map((m) => m.id),
  );

  const hasOpenTasks = openTasks?.length !== 0;
  const hasAllAuditsCompleted = !audits || audits.every((a) => auditHelpers.isCompletedSuccess(a));

  if (!hasOpenTasks && hasAllAuditsCompleted) {
    await finishTransaction(deal, DEAL_ENDED_STATUSES.CLOSED, userId);

    userApi.sendClientTransactionClosedEmail(deal);
  }
};
